module.exports = __webpack_public_path__ + "static/media/exc.bf46a6a0.png";